import React from "react";
import App from "./App";

// 最初に開いたときのスクロール位置は src/components/ScrollToTop.jsx で決める
const AppWrapper = () => <App />;

export default AppWrapper;
